import { render, staticRenderFns } from "./material-warehousing.vue?vue&type=template&id=223b6822&scoped=true"
import script from "./material-warehousing.vue?vue&type=script&lang=js"
export * from "./material-warehousing.vue?vue&type=script&lang=js"
import style0 from "./material-warehousing.vue?vue&type=style&index=0&id=223b6822&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "223b6822",
  null
  
)

export default component.exports